<!--
 * @Author: RYL
 * @Description: 设置报警的共用弹窗表单
 * @Date: 2020-12-10 09:51:23
 * @LastEditTime: 2020-12-28 17:27:16
-->
<template>
  <div v-if="dialogVisible">
    <el-dialog :title="$t('lang.collect.setalarm')" :visible.sync="dialogVisible" @close="dialogClose" center
      append-to-body>
      <el-form :model="alarmInfo" ref="alarmInfo" label-width="158px" label-position="right" :rules="rules">
        <el-form-item :label="$t('lang.collect.Callthepolice')">
          <el-switch v-model="alarmInfo.state"></el-switch>
        </el-form-item>
        <div>
          <el-form-item :label="$t('lang.collect.Triggeringconditions')">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-select v-model="alarmInfo.trigger" size="mini" clearable>
                  <el-option v-for="item in triggerOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="17" v-if="!notSetValue.includes(alarmInfo.trigger)">
                <el-row :gutter="10">
                  <el-col :span="10">
                    <el-input v-if="!notSetA.includes(alarmInfo.trigger)" size="mini" clearable
                      v-model="alarmInfo.strValA" :placeholder="$t('lang.collect.PleasevalueA')">
                    </el-input>
                  </el-col>
                  <el-col :span="10">
                    <el-input v-if="!notSetB.includes(alarmInfo.trigger)" size="mini" clearable
                      v-model="alarmInfo.strValB" :placeholder="$t('lang.collect.PleasevalueB')">
                    </el-input>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item :label="$t('lang.collect.Alarmpushcontent')" prop="alarmContent">
            <el-input type="textarea" :rows="4" v-model="alarmInfo.alarmContent"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.collect.Restorepushcontent')">
            <el-input type="textarea" :rows="4" v-model="alarmInfo.recoverContent"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="dialogVisible = false">{{
          $t("lang.Button.cancel")
        }}</el-button>
        <el-button v-if="isPermission" type="primary" size="mini" :disabled="isDes" @click="submitAlarm">{{
          $t("lang.Button.confirm") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getAlarm, editAlarm, addAlarm } from "@/api/cloudMonitor/paramsList";
import { cloneDeep, isEqual } from "lodash";
import { getPermission } from "@/cookie/cookie";
export default {
  data() {
    return {
      dialogVisible: false,
      alarmInfo: {
        state: false,
        trigger: 1,
        valA: "",
        valB: "",
        alarmContent: "",
        recoverContent: "",
      },
      enabel: false,
      notSetValue: [1, 2], // 不设置数值的条件
      notSetA: [4], // 不设置数值A的白名单
      notSetB: [3, 7], //不设置数值B的白名单
      triggerOptions: [
        { label: this.$t("lang.collect.SwitchOFF"), value: 1 },
        { label: this.$t("lang.collect.switchON"), value: 2 },
        { label: this.$t("lang.collect.valuelessA"), value: 3 },
        { label: this.$t("lang.collect.valuegreaterB"), value: 4 },
        { label: this.$t("lang.collect.ValuegreaterAlessB"), value: 5 },
        { label: this.$t("lang.collect.ValuelessAgreaterB"), value: 6 },
        { label: this.$t("lang.collect.valueisequaltoA"), value: 7 },
      ],
      type: "add", // 判断报警是第一次添加还是编辑
      Permission: [],
      isPermission: false, // 判断是否要显示确定按钮
      alarmInfoClone: {},
      isDes: true,
      rules: {
        alarmContent: [
          { required: true, message: this.$t("lang.collect.pleaseTcontent"), trigger: ["blur"] }
        ]
      }
    };
  },
  watch: {
    alarmInfo: {
      handler(newV) {
        this.isDes = isEqual(this.alarmInfo, this.alarmInfoClone);
      },
      deep: true,
    },
  },
  methods: {
    clearData() {
      this.alarmInfo = {
        state: false,
        trigger: 1,
        strValA: "",
        strValB: "",
        alarmContent: "",
        recoverContent: "",
      };
    },
    show(item) {
      this.Permission = getPermission();
      if (item && item.id) {
        // 获取变量报警规则
        getAlarm(item.id)
          .then((result) => {
            if (result.data.code === 0) {
              if (result.data.data) {
                this.alarmInfo = result.data.data;
                this.alarmInfo.state = this.alarmInfo.state == 0 ? true : false;
                this.type = "edit";
                // 判断是否允许编辑
                if (this.Permission.indexOf(253) !== -1) {
                  this.isPermission = true;
                } else {
                  this.isPermission = false;
                }
              } else {
                this.clearData();
                this.type = "add";
                // 判断是否允许添加
                if (this.Permission.indexOf(252) !== -1) {
                  this.isPermission = true;
                } else {
                  this.isPermission = false;
                }
              }
              this.alarmInfoClone = cloneDeep(this.alarmInfo);
            } else {
              this.$message.error(this.$t("lang.collect.Failedtoobtain"));
            }
            this.alarmInfo.vid = item.id;
          })
          .catch((err) => {
            this.$message.error(this.$t("lang.terminalList.Requestfailed"));
          });
        this.dialogVisible = true;
      }
    },

    submitAlarm() {
      this.$refs.alarmInfo.validate((res) => {
        if (res) {
          let submitData = cloneDeep(this.alarmInfo);
          submitData.state = submitData.state ? 0 : 1;
          if (this.notSetValue.includes(submitData.trigger)) {
            submitData.strValA = undefined;
            submitData.strValB = undefined;
          } else if (this.notSetA.includes(submitData.trigger)) {
            submitData.strValA = undefined;
          } else if (this.notSetB.includes(submitData.trigger)) {
            submitData.strValB = undefined;
          }
          if (this.type === "add") {
            addAlarm(submitData)
              .then((res) => {
                if (res.data.code === 0) {
                  this.$message.success(this.$t("lang.collect.Setupsucceeded"));
                  this.dialogVisible = false;
                } else {
                  this.$message.error(this.$t("lang.collect.Setupfailed"));
                }
              })
              .catch(() => {
                this.$message.error(this.$t("lang.collect.Setupfailed"));
              });
          } else {
            editAlarm(submitData)
              .then((res) => {
                if (res.data.code === 0) {
                  this.$message.success(this.$t("lang.collect.Setupsucceeded"));
                  this.dialogVisible = false;
                } else {
                  this.$message.error(this.$t("lang.collect.Setupfailed"));
                }
              })
              .catch(() => {
                this.$message.error(this.$t("lang.collect.Setupfailed"));
              });
          }
        }
      })
    },
    dialogClose() {
      this.alarmInfo = {
        state: false,
        trigger: 1,
        valA: "",
        valB: "",
        alarmContent: "",
        recoverContent: "",
      }
    }
  },
};
</script>
